import React, { useEffect } from "react";
import { ClipboardList } from "lucide-react";
import { useInventoryTransferQuery } from "../../../hooks/inventory/useInventoryTransferQuery";
import PendingTransferModal from "../transfer/Modals/PendingTransferModal";

const PendingTransfersButton: React.FC = () => {
  const {
    handlerGetPendingCount,
    pendingCount,
    handlerOpenPendingModal,
    handlerClosePendingModal,
    showPendingTransferModal,
  } = useInventoryTransferQuery();

  // 🚀 Cargar cantidad de pendientes al montar
  useEffect(() => {
    handlerGetPendingCount();
  }, []);

  return (
    <>
      {/* 🔘 Botón principal */}
      <button
        type="button"
        onClick={handlerOpenPendingModal}
        className="flex items-center justify-center gap-2 rounded bg-primary px-4.5 py-2.5 
                   text-sm font-medium text-white hover:bg-opacity-90 transition"
      >
        <ClipboardList className="h-4 w-4" />
        <span className="leading-tight">Solicitar Traslado</span>

        {/* 🔹 Contador dinámico */}
        <span className="ml-2 rounded-full bg-white bg-opacity-20 px-2 py-0.5 text-xs font-semibold">
          {pendingCount ?? 0}
        </span>
      </button>

      {/* 🪟 Modal de traslados pendientes */}
      <PendingTransferModal
        isOpen={showPendingTransferModal}
        onClose={handlerClosePendingModal}
      />
    </>
  );
};

export default PendingTransfersButton;
